<template>
  <div>
    <app-loader v-show="$store.state.appConfig.showLoader" />
    <div
      v-if="showMessage"
      class="mobileWrapper ReviewPageBg"
    >
      <div class="ReviewPageForm floatCss">
        <b-row>
          <b-col cols="12">
            <div class="review-top-block floatCss">
              <h3>You've retrieved MyInfo with Singpass.</h3>
              <div class="retrieve-block floatCss">
                <b-button
                  class="retrieveagain-btn p-0"
                  variant="link"
                  @click="singpassLogin"
                >
                  Retrieve again
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form
              class="float-label"
              @submit.prevent="savePurchaserData"
            >
              <validation-observer
                ref="purchaserDetailForm"
              >
                <!-- Personal Details -->
                <b-row>
                  <b-col cols="12">
                    <div class="review-tittle-block floatCss">
                      <h2>New purchaser details</h2>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="review-form-wrapper floatCss">
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="Your Name as per NRIC"
                          vid="name"
                          rules="required"
                        >
                          <b-form-group
                            label="Name*"
                            label-for="input-name"
                            label-cols-md="4"
                          >
                            <b-form-input
                              id="input-name"
                              v-model="form.name"
                              placeholder="e.g. Michelle Tay"
                              required
                              disabled
                              style="text-transform: uppercase"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="Your NRIC"
                          vid="nric"
                          rules="required"
                        >
                          <b-form-group
                            label="NRIC*"
                            label-for="input-nric"
                            label-cols-md="4"
                          >
                            <b-form-input
                              id="input-nric"
                              v-model="form.nric"
                              placeholder="e.g. S7069842D"
                              required
                              disabled
                              style="text-transform: uppercase"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="Your Nationality"
                          vid="nationality"
                          rules="required"
                        >
                          <b-form-group
                            label="Nationality"
                            label-for="input-nationality"
                            label-cols-md="4"
                          >
                            <b-form-input
                              id="input-nationality"
                              v-model="form.nationality"
                              placeholder="e.g. Singaporean"
                              disabled
                              style="text-transform: uppercase"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="Sex"
                          vid="sex"
                          rules="required"
                        >
                          <b-form-group
                            label="Sex"
                            label-for="input-sex"
                            label-cols-md="4"
                          >
                            <b-form-input
                              id="input-sex"
                              v-model="form.sex"
                              placeholder="e.g. Male"
                              disabled
                              style="text-transform: uppercase"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="DOB"
                          vid="dob"
                          rules="required"
                        >
                          <b-form-group
                            label="Date of Birth*"
                            label-for="input-dob"
                            label-cols-md="4"
                          >
                            <b-form-input
                              id="input-dob"
                              v-model="form.dob"
                              placeholder="e.g. 01/01/1990"
                              disabled
                              style="text-transform: uppercase"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="Email"
                          vid="email"
                          rules="required"
                        >
                          <b-form-group
                            label="Email Address*"
                            label-for="input-email"
                            label-cols-md="4"
                            label-class="diff-color-label"
                          >
                            <b-form-input
                              id="input-email"
                              v-model="form.email"
                              type="email"
                              :class="{ 'diff-border': !isEmailLocked }"
                              placeholder="e.g. michelle@gmail.com"
                              required
                              :readonly="isEmailLocked"
                              @focus="onEmailFieldClick"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                      <div class="rv-single-input floatCss">
                        <b-row class="custom-padding-row">
                          <b-col
                            cols="5"
                            class="custom-padding-col"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="Country Code"
                              vid="country-code"
                              rules="required"
                            >
                              <b-form-group
                                label="Country Code*"
                                label-for="input-country-code"
                                label-class="diff-color-label"
                              >
                                <b-form-input
                                  id="input-country-code"
                                  v-model="form.countryCode"
                                  class="diff-border"
                                  placeholder="+65"
                                  required
                                />
                              </b-form-group>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-col>
                          <b-col
                            cols="7"
                            class="custom-padding-col"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="Contact No."
                              vid="contactNumber"
                              rules="required"
                            >
                              <b-form-group
                                label="Contact No.*"
                                label-for="input-contact"
                                label-class="diff-color-label"
                              >
                                <b-form-input
                                  id="input-contact"
                                  v-model="form.contactNumber"
                                  class="diff-border"
                                  placeholder="e.g. 91788756"
                                  required
                                />
                              </b-form-group>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <!-- Permanent Address -->
                <b-row>
                  <b-col cols="12">
                    <div class="review-tittle-block floatCss">
                      <h2>Residential address</h2>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <div class="review-form-wrapper floatCss">
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="Address Line 1"
                          vid="per-addr1"
                          rules="required"
                        >
                          <b-form-group
                            label="Address Line 1*"
                            label-for="input-per-addr1"
                            label-cols-md="4"
                          >
                            <b-form-input
                              id="input-per-addr1"
                              v-model="form.perAddress1"
                              placeholder="Street / Building name"
                              required
                              disabled
                              style="text-transform: uppercase"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="Address Line 2"
                          vid="per-addr2"
                          rules="required"
                        >
                          <b-form-group
                            label="Address Line 2"
                            label-for="input-per-addr2"
                            label-cols-md="4"
                          >
                            <b-form-input
                              id="input-per-addr2"
                              v-model="form.perAddress2"
                              placeholder="Unit / Floor"
                              required
                              disabled
                              style="text-transform: uppercase"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="Country"
                          vid="perCountry"
                          rules="required"
                        >
                          <b-form-group
                            label="Country*"
                            label-for="input-per-country"
                            label-cols-md="4"
                          >
                            <b-form-input
                              id="input-per-country"
                              v-model="form.perCountry"
                              placeholder="e.g. Singapore"
                              required
                              disabled
                              style="text-transform: uppercase"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="Postal Code"
                          vid="per-postcode"
                          rules="required"
                        >
                          <b-form-group
                            label="Postal Code*"
                            label-for="input-per-postcode"
                            label-cols-md="4"
                          >
                            <b-form-input
                              id="input-per-postcode"
                              v-model="form.perPostcode"
                              placeholder="e.g. 679246"
                              required
                              disabled
                              style="text-transform: uppercase"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <!-- Same as correspondence address checkbox -->
                <b-row>
                  <b-col cols="12">
                    <div class="review-form-wrapper floatCss">
                      <div class="rv-single-input floatCss">
                        <b-form-checkbox
                          id="checkbox-same-address"
                          v-model="sameAsCorrespondence"
                          name="checkbox-same-address"
                        >
                          Mailing address same as residential address
                        </b-form-checkbox>
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <!-- Correspondence Address -->
                <b-row v-if="!sameAsCorrespondence">
                  <b-col cols="12">
                    <div class="review-tittle-block floatCss">
                      <h2>Mailing address</h2>
                    </div>
                  </b-col>
                  <b-col cols="12">
                    <div class="review-form-wrapper floatCss">
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="Address Line 1"
                          vid="cor-addr1"
                          rules="required"
                        >
                          <b-form-group
                            label="Address Line 1*"
                            label-for="input-cor-addr1"
                            label-cols-md="4"
                            label-class="diff-color-label"
                          >
                            <b-form-input
                              id="input-cor-addr1"
                              v-model="form.corAddress1"
                              placeholder="Street / Building name"
                              class="diff-border"
                              required
                              style="text-transform: uppercase"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="Address Line 2"
                          vid="cor-addr2"
                          rules="required"
                        >
                          <b-form-group
                            label="Address Line 2"
                            label-for="input-cor-addr2"
                            label-cols-md="4"
                            label-class="diff-color-label"
                          >
                            <b-form-input
                              id="input-cor-addr2"
                              v-model="form.corAddress2"
                              placeholder="Unit / Floor"
                              class="diff-border"
                              required
                              style="text-transform: uppercase"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="Country"
                          vid="cor-country"
                          rules="required"
                        >
                          <b-form-group
                            label="Country*"
                            label-for="input-cor-country"
                            label-cols-md="4"
                            label-class="diff-color-label"
                          >
                            <!-- <b-form-input
                              id="input-cor-country"
                              v-model="form.corCountry"
                              placeholder="e.g. Singapore"
                              required
                              style="text-transform: uppercase"
                            /> -->
                            <v-select
                              id="input-cor-country"
                              v-model="form.corCountry"
                              class="diff-border"
                              :options="countryOptions"
                              :clearable="false"
                              placeholder="Select a country"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                      <div class="rv-single-input floatCss">
                        <validation-provider
                          #default="{ errors }"
                          name="Postal Code"
                          vid="cor-postcode"
                          rules="required"
                        >
                          <b-form-group
                            label="Postal Code*"
                            label-for="input-cor-postcode"
                            label-cols-md="4"
                            label-class="diff-color-label"
                          >
                            <b-form-input
                              id="input-cor-postcode"
                              v-model="form.corPostcode"
                              placeholder="e.g. 679246"
                              class="diff-border"
                              required
                              style="text-transform: uppercase"
                            />
                          </b-form-group>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </validation-observer>
            </b-form>
          </b-col>
        </b-row>
      </div>
      <div class="ReviewPageBottom floatCss">
        <b-row>
          <b-col cols="12">
            <div class="ReviewSubmit-btn floatCss">
              <b-button
                class="pr-btn-2"
                @click="savePurchaserData"
              >
                Save purchaser details
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BFormCheckbox, BButton,
} from 'bootstrap-vue'
import moment from 'moment'
import vSelect from 'vue-select'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppLoader from '../AppLoader.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    BButton,
    AppLoader,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      sameAsCorrespondence: true,
      showMessage: false,
      tokenDetail: {},
      transferRequest: {},
      packageName: '',
      titleText: 'Change of Purchaser',
      countryOptions: ['SINGAPORE', 'MALAYSIA', 'OTHERS'],
      required,
      form: {
        name: '',
        nric: '',
        email: '',
        countryCode: '+65',
        contactNumber: '',
        sex: '',
        nationality: '',
        dob: '',
        perAddress1: '',
        perAddress2: '',
        perPostcode: '',
        perCountry: '',
        corAddress1: '',
        corAddress2: '',
        corPostcode: '',
        corCountry: '',
      },
    }
  },
  computed: {
    isEmailLocked() {
      return !!(this.transferRequest.newPurchaser && this.transferRequest.newPurchaser.isRegistered)
    },
  },
  watch: {
    sameAsCorrespondence(val) {
      if (val) {
        this.form.corAddress1 = this.form.perAddress1
        this.form.corAddress2 = this.form.perAddress2
        this.form.corPostcode = this.form.perPostcode
        this.form.corCountry = this.form.perCountry
      } else {
        this.form.corAddress1 = ''
        this.form.corAddress2 = ''
        this.form.corPostcode = ''
        this.form.corCountry = ''
      }
    },
  },
  beforeMount() {
    const { token } = this.$route.params
    if (token) {
      this.$http.get('front-end/file-transfer/file-detail', { params: { token } })
        .then(response => {
          if (response.data.success) {
            if (response.data.validToken) {
              this.tokenDetail = response.data.token || {}
              this.transferRequest = response.data.transferRequest || {}
              if (this.transferRequest.transferType === 'ownership') {
                this.titleText = 'Transfer of ownership'
              }
              this.packageName = response.data.packageName
              if (this.transferRequest.currentStatus === 'Pending NP') {
                this.showMessage = true
                const userInfo = JSON.parse(localStorage.getItem('singpassUserInfo'))
                if (userInfo) {
                  this.form.name = userInfo.name ? userInfo.name : ''
                  this.form.nric = userInfo.nric ? userInfo.nric : ''
                  this.form.sex = 'N/A'
                  if (userInfo.sex) {
                    if (userInfo.sex === 'M') {
                      this.form.sex = 'MALE'
                    } else if (userInfo.sex === 'F') {
                      this.form.sex = 'FEMALE'
                    }
                  }
                  this.form.nationality = 'OTHERS'
                  if (userInfo.nationality) {
                    if (userInfo.nationality === 'SG') {
                      this.form.nationality = 'SINGAPOREAN'
                    } else if (userInfo.nationality === 'MY') {
                      this.form.nationality = 'MALAYSIAN'
                    }
                  }
                  this.form.email = userInfo.email ? userInfo.email : ''
                  this.form.countryCode = userInfo.countryCode ? userInfo.countryCode : '+65'
                  this.form.contactNumber = userInfo.mobile ? userInfo.mobile : ''
                  this.form.dob = userInfo.dob ? moment(userInfo.dob).format('DD/MM/YYYY') : ''
                  this.form.perAddress1 = userInfo.address1 ? userInfo.address1 : ''
                  this.form.perAddress2 = userInfo.address2 ? userInfo.address2 : ''
                  this.form.perPostcode = userInfo.postCode ? userInfo.postCode : ''
                  this.form.perCountry = userInfo.country ? userInfo.country : ''
                  this.form.corAddress1 = userInfo.address1 ? userInfo.address1 : ''
                  this.form.corAddress2 = userInfo.address2 ? userInfo.address2 : ''
                  this.form.corPostcode = userInfo.postCode ? userInfo.postCode : ''
                  this.form.corCountry = userInfo.country ? userInfo.country : ''
                }
                if (this.transferRequest.newPurchaser) {
                  if (this.transferRequest.newPurchaser.contact) {
                    const parsedContact = this.parsePhoneNumber(this.transferRequest.newPurchaser.contact || '')
                    this.form.countryCode = parsedContact.countryCode
                    this.form.contactNumber = parsedContact.number
                  }
                  if (this.transferRequest.newPurchaser.email) {
                    this.form.email = this.transferRequest.newPurchaser.email
                  }
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'You have already completed this step',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Expired link',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }
  },
  methods: {
    onEmailFieldClick(event) {
      if (!this.isEmailLocked) return
      event.target.blur()
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'This email address is your main correspondence email, as well as your account email (to access Nirvana SG). To edit it, use the Nirvana SG app.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    },
    singpassLogin() {
      localStorage.setItem('fileTransferToken', this.$route.params.token)
      const formData = new FormData()
      formData.append('purpose', 'file-transfer-purchaser')

      this.$http.post('front-end/singpass/file-transfer/purchaser', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          localStorage.setItem('singpassAuthorizationSession', response.data.sessionID)
          // console.log(response.data.authorizationUrl)
          window.location.href = response.data.authorizationUrl
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    savePurchaserData() {
      this.$refs.purchaserDetailForm.validate().then(success => {
        if (success) {
          const missingFields = []
          if (!this.form.name) missingFields.push('Name')
          if (!this.form.nric) missingFields.push('NRIC')
          if (!this.form.perAddress1) missingFields.push('Address Line 1')
          if (!this.form.perCountry) missingFields.push('Country')
          if (!this.form.perPostcode) missingFields.push('Postal Code')
          if (missingFields.length) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Missing Singpass data: ${missingFields.join(', ')}. Please retrieve again.`,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
            return
          }
          const draft = {
            name: this.form.name.toUpperCase(),
            nric: this.form.nric.toUpperCase(),
            sex: this.form.sex,
            nationality: this.form.nationality.toUpperCase(),
            dob: this.form.dob.toUpperCase(),
            contact: `${this.form.countryCode}${this.form.contactNumber}`,
            email: this.form.email,
            perAddress1: this.form.perAddress1.toUpperCase(),
            perAddress2: this.form.perAddress2.toUpperCase(),
            perPostcode: this.form.perPostcode.toUpperCase(),
            perCountry: this.form.perCountry.toUpperCase(),
            corAddress1: this.form.corAddress1.toUpperCase(),
            corAddress2: this.form.corAddress2.toUpperCase(),
            corPostcode: this.form.corPostcode.toUpperCase(),
            corCountry: this.form.corCountry.toUpperCase(),
          }
          localStorage.setItem('fileTransferDraft_purchaser', JSON.stringify(draft))
          this.$router.push({ name: 'file-transfer-transferring-detail', params: { token: this.$route.params.token } })
        }
      })
    },
  },
}
</script>
